import {
  experience_banner_pc,
  experience_banner_sp,
  rental_car_banner_pc,
  rental_car_banner_sp,
} from 'media';

const campaignData = [
  {
    type: 'banner',
    content: {
      url: 'Traveler_Common.Rental_Car_URL',
      title: 'Top.Rental_Car_Banner.Title',
      text: 'Top.Rental_Car_Banner.Subtitle',
      ctaText: 'Top.Rental_Car_Banner.Explore_Rentals',
      imagePC: rental_car_banner_pc,
      imageSP: rental_car_banner_sp,
      pageName: 'rental_car_banner',
    },
    locations: ['top_page', 'booking_step_3', 'upcoming_reservation'],
  },
  {
    type: 'banner',
    content: {
      url: 'Traveler_Common.RTE_URL',
      title: 'Top.Rakuten_Travel_Experience_Banner.Title',
      text: 'Top.Rakuten_Travel_Experience_Banner.Subtitle',
      ctaText: 'Traveler_Common.RTE_CTA',
      imagePC: experience_banner_pc,
      imageSP: experience_banner_sp,
      pageName: 'rte_banner',
      imageStylePC: {
        width: '408px',
        left: '-37px',
        bottom: '-94px',
      },
      queryParam: 'scid=wi_trv_everest_top-banner',
    },
    locations: ['top_page'],
  },
  {
    type: 'banner',
    content: {
      url: 'Traveler_Common.RTE_URL',
      title: 'Booking_Step3.Rakuten_Travel_Experience_Banner.Title',
      text: 'Booking_Step3.Rakuten_Travel_Experience_Banner.Subtitle',
      ctaText: 'Traveler_Common.RTE_CTA',
      imagePC: experience_banner_pc,
      imageSP: experience_banner_sp,
      pageName: 'rte_banner',
      imageStylePC: {
        width: '321px',
        top: '-69px',
        left: '-103px',
      },
      queryParam: 'scid=wi_trv_everest_confirmation-banner',
    },
    locations: ['booking_step_3'],
    conditions: {
      all: [
        {
          key: 'bookingStep.destination.country',
          value: 'Japan',
          operator: 'equal',
        },
      ],
    },
  },
  {
    type: 'banner',
    content: {
      url: 'Traveler_Common.RTE_URL',
      title: 'Reservation_List.Rakuten_Travel_Experience_Banner.Title',
      text: 'Reservation_List.Rakuten_Travel_Experience_Banner.Subtitle',
      ctaText: 'Traveler_Common.RTE_CTA',
      imagePC: experience_banner_pc,
      imageSP: experience_banner_sp,
      pageName: 'rte_banner',
      imageStylePC: {
        width: '408px',
        left: '-37px',
        bottom: '-94px',
      },
      queryParam: 'scid=wi_trv_everest_upcoming-banner',
    },
    locations: ['upcoming_reservation'],
    conditions: {
      all: [
        {
          key: 'reservationList.upcomingReservations.destination.Japan.count',
          value: 1,
          operator: 'greaterThanOrEqual',
        },
      ],
    },
  },
];

export default campaignData;
